module.exports = __webpack_public_path__ + "static/media/logo-authentification.3c99a5e4.png";